import type { CustomerJourneyStageView } from '@solar/contracts';

import { cx } from '../lib/class-names';

import styles from './JourneyStepper.module.css';

function stageStatusLabel(state: CustomerJourneyStageView['state']): string | null {
  if (state === 'complete') {
    return 'Complete';
  }

  if (state === 'current') {
    return 'In progress';
  }

  return null;
}

export function JourneyStepper({
  stages,
}: {
  stages: readonly CustomerJourneyStageView[];
}): React.JSX.Element | null {
  if (stages.length === 0) {
    return null;
  }

  return (
    <ol className={styles.stepper} aria-label="Solar journey progress">
      {stages.map((stage, index) => {
        const statusLabel = stageStatusLabel(stage.state);

        return (
          <li
            className={cx(
              styles.step,
              stage.state === 'complete' && styles.stepComplete,
              stage.state === 'current' && styles.stepCurrent,
            )}
            key={stage.key}
            aria-current={stage.state === 'current' ? 'step' : undefined}
          >
            <span className={styles.marker} aria-hidden="true">
              {stage.state === 'complete' ? '✓' : index + 1}
            </span>
            <div className={styles.labelBlock}>
              <span className={styles.label}>{stage.label}</span>
              {statusLabel !== null && <span className={styles.status}>{statusLabel}</span>}
            </div>
          </li>
        );
      })}
    </ol>
  );
}
